export function MP(tk) {
  console.log(tk);
  return new Promise(function (resolve, reject) {
    // 天地图已在 index.html 中加载，检查是否就绪
    if (window.T && window.T.Map) {
      resolve(window.T);
      return;
    }
    // 如果未就绪，等待加载完成
    window.initTianditu = function () {
      resolve(window.T);
    };
    var script = document.createElement('script');
    script.type = 'text/javascript';
    // 天地图 HTTPS 配置
    window.HOST_TYPE = "2";
    script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=${tk}&callback=initTianditu`;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}
